import { SamplePack } from '@arpeggi/shared'
import { FC } from 'react'
import { PlayIcon } from '../../../__legacy__/components/core/icons'
import { useTreeState } from '../../../__legacy__/stores/Root'
import { PlaybackButton } from '../primitives'

export const SPPlaybackButton: FC<{ sp: SamplePack }> = ({ sp }) => {
  const { globalPlayer } = useTreeState()

  const handleClick = async () => {
    globalPlayer.stop()
    await globalPlayer.setArpMediaIndex(sp.coverArpMedia.id, true)
    await globalPlayer.play()
  }

  if (!sp.coverArpMedia) return null

  return (
    <PlaybackButton.Root
      css={{ position: 'absolute', top: 0, right: 0, width: '120px' }}
      onClick={handleClick}
    >
      <PlaybackButton.Icon
        css={{ marginRight: '4px', width: '16px', height: '16px' }}
        as={PlayIcon}
      />
      Play Demo
    </PlaybackButton.Root>
  )
}
